export default {
  text: 'Olá Joaquim!'
}
